<template>
  <div class="illness-history-wrap">
    <div class="illness-history-content">
      <Form
        v-if="headerUserRest.status == 2"
        label-position="right"
        :label-width="180"
        ref="formItem"
        id="form-input"
        :model="formItem"
      >
        <FormItem
          id="input-textarea"
          label="患者病情："
          class="FormItem"
          :required="ruleValidate.state.required"
          v-if="showItems.includes('huanzhebingqing')"
        >
          <Select v-model="formItem.state" size="small" class="Select">
            <Option
              v-for="item in huanzhebingqingList"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </FormItem>
        <FormItem
          id="input-textarea"
          label="主诉："
          class="FormItem"
          :required="ruleValidate['infos.zhusu'].required"
          v-if="showItems.includes('zhusu')"
        >
          <Input
            v-model="formItem.infos.zhusu"
            type="textarea"
            autosize
            :maxlength="50"
            size="small"
          />
        </FormItem>
        <FormItem
          id="input-textarea"
          label="过敏史："
          class="FormItem"
          :required="ruleValidate['infos.guominshi'].required"
          v-if="showItems.includes('guominshi')"
        >
          <Input
            size="small"
            autosize
            type="textarea"
            v-model="formItem.infos.guominshi"
            :maxlength="250"
          />
        </FormItem>
        <FormItem
          id="input-textarea"
          label="现病史："
          class="FormItem"
          :required="ruleValidate['infos.xianbingshi'].required"
          v-if="showItems.includes('xianbingshi')"
        >
          <Input
            size="small"
            autosize
            type="textarea"
            v-model="formItem.infos.xianbingshi"
            :maxlength="250"
          />
        </FormItem>
        <FormItem
          id="input-textarea"
          label="用药史："
          class="FormItem"
          :required="ruleValidate['infos.yongyaoshi'].required"
          v-if="showItems.includes('yongyaoshi')"
        >
          <Input
            size="small"
            autosize
            type="textarea"
            v-model="formItem.infos.yongyaoshi"
            :maxlength="250"
          />
        </FormItem>
        <FormItem
          id="input-textarea"
          label="既往史："
          class="FormItem"
          :required="ruleValidate['infos.jiwangshi'].required"
          v-if="showItems.includes('jiwangshi')"
        >
          <Input
            size="small"
            autosize
            type="textarea"
            v-model="formItem.infos.jiwangshi"
            :maxlength="250"
          />
        </FormItem>
        <FormItem
          id="input-textarea"
          label="婚育史："
          class="FormItem"
          :required="ruleValidate['infos.hunyushi'].required"
          v-if="showItems.includes('hunyushi')"
        >
          <Input
            size="small"
            autosize
            type="textarea"
            v-model="formItem.infos.hunyushi"
            :maxlength="250"
          />
        </FormItem>

       <FormItem id="input-textarea" label="诊断：" class="FormItem" :required="ruleValidate.diagnosis.required"  v-if="showItems.includes('zhenduan')">
                <img class="add-icon-style" src="../../../../assets/images/add.png" alt="添加诊断" @click="handleraAddZhenDuan" />
                <div class="diagnosisBox" v-for="(diagnosisItem, diagnosisIndex) in formItem.diagnosis" :key="diagnosisIndex">
                    <Select size="small"
                    class="Select"
                    transfer
                    v-model="diagnosisItem.code"
                    filterable
                    placeholder="请选择诊断"
                    remote
                    :label-in-value='true'
                    :remote-method="query => {getZhenDuanList(query,diagnosisIndex)}"
                    @on-change="query => {setOption(query,diagnosisIndex)}"
                    :loading="loading">
                       <Option v-for="option in zhenDuanSearchResult[diagnosisIndex]" :value="option.value" :key="option.value" :label="option.label">
                            <span>{{ option.label}}</span>
                            <span style="float:right;">{{ option.value.split(' ')[0]}}</span>

                       </Option>

                    </Select>
                    <img class="sub-icon-style" src="../../../../assets/images/sub2.png" alt="删除诊断" v-if="diagnosisIndex !== 0" @click="handleradelZhenDuan(diagnosisIndex)" />
                </div>
        </FormItem>
        <FormItem
          id="input-textarea"
          class="FormItem"
          style="margin-bottom: 32px"
          label="处置意见："
          :required="ruleValidate['infos.chuzhiyijian'].required"
          v-if="showItems.includes('chuzhiyijian')"
        >
          <Input
            autosize
            type="textarea"
            v-model="formItem.infos.chuzhiyijian"
            :maxlength="250"
          />
        </FormItem>
        <FormItem id="input-textarea">
          <div class="illness-submit" @click="submitIllness('formItem')">
            <div>保存</div>
          </div>
        </FormItem>
      </Form>
      <Form
        v-else
        :model="formItem"
        id="form-input"
        class="form-inputNo"
        label-position="right"
        :label-width="180"
      >
        <FormItem
          class="FormItem"
          id="select-style"
          label="患者病情："
          v-if="showItems.includes('huanzhebingqing')"
        >
          <div class="content-wp">
            <span class="form-span-style">{{
              huanzhebingqingList[formItem.state].label
            }}</span>
          </div>
        </FormItem>
        <FormItem
          class="FormItem"
          id="input-text"
          label="主诉："
          v-if="showItems.includes('zhusu')"
        >
          <div class="content-wp">
            <span class="form-span-style" v-html="formItem.infos.zhusu"></span>
          </div>
        </FormItem>
        <FormItem
          class="FormItem"
          id="input-text"
          label="过敏史："
          v-if="showItems.includes('guominshi')"
        >
          <div class="content-wp">
            <span
              class="form-span-style"
              v-html="formItem.infos.guominshi"
            ></span>
          </div>
        </FormItem>
        <FormItem
          class="FormItem"
          id="input-text"
          label="现病史："
          v-if="showItems.includes('xianbingshi')"
        >
          <div class="content-wp">
            <span
              class="form-span-style"
              v-html="formItem.infos.xianbingshi"
            ></span>
          </div>
        </FormItem>
        <FormItem
          class="FormItem"
          id="input-text"
          label="既往史："
          v-if="showItems.includes('jiwangshi')"
        >
          <div class="content-wp">
            <span
              class="form-span-style"
              v-html="formItem.infos.jiwangshi"
            ></span>
          </div>
        </FormItem>
        <FormItem
          class="FormItem"
          id="input-text"
          label="用药史："
          v-if="showItems.includes('yongyaoshi')"
        >
          <div class="content-wp">
            <span
              class="form-span-style"
              v-html="formItem.infos.yongyaoshi"
            ></span>
          </div>
        </FormItem>
        <FormItem
          class="FormItem"
          id="input-text"
          label="婚育史："
          v-if="showItems.includes('hunyushi')"
        >
          <div class="content-wp">
            <span
              class="form-span-style"
              v-html="formItem.infos.hunyushi"
            ></span>
          </div>
        </FormItem>
        <FormItem
          class="FormItem"
          id="input-text"
          label="诊断："
          v-if="showItems.includes('zhenduan')"
        >
          <div class="content-wp">
            <span
              class="form-span-style"
              style="margin-right: 10px"
              v-for="(item, diagnosisindex) in formItem.diagnosis"
              :key="diagnosisindex"
            >
              {{ item.name }}
            </span>
          </div>
        </FormItem>
        <FormItem
          class="FormItem"
          id="input-text"
          style="margin-bottom: 32px"
          label="处置意见："
          v-if="showItems.includes('chuzhiyijian')"
        >
          <div class="content-wp">
            <p class="form-span-style" v-html="formItem.infos.chuzhiyijian"></p>
          </div>
        </FormItem>
      </Form>
    </div>
  </div>
</template>

<script>
import {
  api
} from '@/services'

import { debounce } from '@/utils/tool'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      showItems: [],
      initSearch500: false,
      formItem: {
        infos: {
          zhusu: '',
          xianbingshi: '',
          jiwangshi: '',
          hunyushi: '',
          chuzhiyijian: ''
        },
        diagnosis: [],
        state: 2
      },
      zhenduanList: [],
      showZhenDuanList: [],
      huanzhebingqingList: [
        {
          value: 0,
          label: '危重'
        },
        {
          value: 1,
          label: '急诊'
        },
        {
          value: 2,
          label: '一般'
        },
        {
          value: 3,
          label: '其他'
        }
      ],
      ruleValidate: {},
      // 诊断集合远程搜索的搜索状态
      loading: false,
      // 更具名称搜索的诊断结果
      zhenDuanSearchResult: [],
      diagnosis: []
    }
  },
  methods: {
    changeInfos () {
      let infosData = {}
      if (this.headerUserRest.status != 2) {
        for (var key in this.formItem.infos) {
          infosData[key] = this.formItem.infos[key].replace(/\n/g, '</br>')
        }
        this.$set(this.formItem, 'infos', infosData)
      }
    },
    setOption (obj, index) {
      if (!obj) {
        return false
      }
      let addN = {
        code: obj.value,
        name: obj.label
      }

      this.formItem.diagnosis.splice(index, 1, addN)
      console.log(this.formItem.diagnosis)
    },
    // 添加一行诊断
    handleraAddZhenDuan () {
      if (!this.formItem.diagnosis || this.formItem.diagnosis <= 0) {
        this.formItem.diagnosis = []
      }
      this.formItem.diagnosis.push({
        'name': '',
        'code': ''
      })
      this.$set(this.formItem, 'diagnosis', this.formItem.diagnosis)
    },
    // 删除某行诊断
    handleradelZhenDuan (index) {
      this.formItem.diagnosis.splice(index, 1)
    },

    createRuled (Obj) {
      let ruleobj = {}
      let enumObj = {
        huanzhebingqing: '患者病情',
        zhusu: '主诉',
        guominshi: '过敏史',
        xianbingshi: '现病史',
        jiwangshi: '既往史',
        chuzhiyijian: '处置意见',
        zhenduan: '诊断',
        yongyaoshi: '用药史'
      }
      let infosAttr = ['zhusu', 'yongyaoshi', 'xianbingshi', 'jiwangshi', 'guominshi', 'chuzhiyijian']
      let data = Obj.requiredInfos
      Object.keys(data).forEach(item => {
        let attr = ''
        if (infosAttr.includes(item)) {
          attr = 'infos.' + item
        } else if (item === 'huanzhebingqing') {
          attr = 'state'
        } else if (item === 'zhenduan') {
          attr = 'diagnosis'
        } else {
          attr = item
        }
        if (data[item] === '1' && item !== 'zhenduan') {
          ruleobj[attr] = { required: true, message: `${enumObj[item]}为必填项` }
        } else if (data[item] === '1' && item === 'zhenduan') {
          ruleobj[attr] = { required: true, message: `${enumObj[item]}为必填项` }
        } else {
          ruleobj[attr] = { required: false, message: `${enumObj[item]}为必填项` }
        }
      })
      return ruleobj
    },
    // 病例信息
    adminOnlineCaseItem () {
      if (!this.orderId) return
      return api.adminOnlineCaseItem({
        data: {
          params: {
            orderId: this.orderId
          }
        }
      }).then(res => {
        if (res.code === 0) {
          this.$store.commit('prvateConsultation/setIsDiagnosis', res.data.status)
          // 展示的条目i
          this.showItems = Object.keys(res.data.infos)
          if (res.data.isShowDiagnosis && res.data.isShowDiagnosis === 1) {
            this.showItems.push('zhenduan')
          }
          if (res.data.requiredInfos) {
            this.ruleValidate = this.createRuled(res.data)
            console.log(this.ruleValidate)
          }
          setTimeout(() => {
            this.$set(this.formItem, 'infos', res.data.infos)
            this.$set(this.formItem, 'state', res.data.state)
          }, 300)

          this.initSearch500 = true
          // let _this = this
          // bughack 由于select框自动远程搜索  或出现某个字段undefined  未找到原因 所以这样修改
          setTimeout(() => {
            this.initSearch500 = false
            this.formItem.diagnosis = []
            this.zhenDuanSearchResult.map(item => {
              this.formItem.diagnosis.push({
                code: item[0].value,
                name: item[0].label
              })
            })
          }, 1000)
          if (res.data.diagnosis.length <= 0) {
            res.data.diagnosis.push({
              code: '',
              name: ''
            })
          }
          this.zhenDuanSearchResult = []
          res.data.diagnosis.map((item, index) => {
            this.zhenDuanSearchResult[index] = []
            this.zhenDuanSearchResult[index].push({
              value: item.code,
              label: item.name.split(' ')[0] + ' ' + item.code
            })
          })
          this.formItem.diagnosis = res.data.diagnosis
          this.changeInfos()
          // this.zhenDuanSearchResult = res.data.diagnosis
        }
      })
    },
    // 根据输入内容搜索的方法
    getZhenDuanList: debounce(function (query1, index) {
      if (this.initSearch500) {
        return false
      }
      let query = query1
      if (query !== '') {
        this.loading = true
        this.searchPrescriptionKinds(query, index)
        this.loading = false
      }
    }, 1000),
    // // ICD-10国际疾病分类搜索
    searchPrescriptionKinds (searchName, index) {
      var that = this
      // this.formItem.diagnosis[index].name = searchName
      api.searchPrescriptionKinds({
        data: {
          params: {
            searchName: searchName.split(' ')[0],
            pageSize: 50,
            pageNum: 1
          }
        }
      }).then(res => {
        if (res.code === 0) {
          let resData = res['data']['list']
          let datalist = []
          console.log(res['data'])
          if (resData && resData.length > 0) {
            resData.map(item => {
              datalist.push({
                label: item.name + ' ' + item.code,
                value: item.code + ' ' + searchName.split(' ')[0]
              })
            })
          }
          // that.zhenDuanSearchResult[index] = []
          // that.zhenDuanSearchResult[index] = datalist
          // that.zhenDuanSearchResult.splice(index, 1, datalist)
          that.$set(that.zhenDuanSearchResult, index, datalist)
          // console.log(that.zhenDuanSearchResult[index])
        }
      })
    },
    // 保存
    submitIllness (name) {
      let errorStr = ''
      let data = Object.keys(this.ruleValidate)
      for (let i = 0; i < data.length; i++) {
        let item = data[i]
        if (item.indexOf('infos') > -1) {
          let arr = item.split('.')
          if (!this.showItems.includes(arr[1])) {
            continue
          }
          if (this.ruleValidate[item].required && !this.formItem.infos[arr[1]]) {
            errorStr = this.ruleValidate[item].message
            break
          }
        } else {
          if (this.ruleValidate[item].required && item === 'diagnosis') {
            if (!this.showItems.includes('zhenduan')) {
              continue
            }
            if (this.formItem.diagnosis.length === 0 || this.formItem.diagnosis.some(item => item.code === '')) {
              errorStr = this.ruleValidate[item].message
              break
            }
          } else if (item.required && !this.formItem['state']) {
            if (!this.showItems.includes('huanzhebingqing')) {
              continue
            }
            errorStr = this.ruleValidate[item].message
            console.log(this.ruleValidate[item].message)
            break
          }
        }
      }
      console.log(errorStr)
      if (errorStr) {
        this.$Message.error(errorStr)
        return
      }
      let diagnosisPut = []
      this.formItem.diagnosis.map(item => {
        diagnosisPut.push({
          code: item.code.split(' ')[0],
          name: item.name.split(' ')[0]
        })
        // item.code = item.code.split(' ')[0]
        // item.name = item.name.split(' ')[0]
      })

      let _this = this

      if (this.orderId !== '') {
        var params = {
          orderId: this.orderId,
          state: this.formItem.state,
          infos: this.formItem.infos,
          diagnosis: diagnosisPut
        }
        api.adminOnlinePutCase({
          data: {
            params
          }
        }).then(res => {
          if (res.code === 0) {
            this.$Message.success('保存成功')
            // _this.formItem.diagnosis = []
            // _this.zhenDuanSearchResult.map(item => {
            //   _this.formItem.diagnosis.push({
            //     code: item[0].value,
            //     name: item[0].label
            //   })
            // })
            this.$store.commit('prvateConsultation/setIsDiagnosis', res.data.status)
          }
        })
      } else {
        this.$Message.error('订单不存在')
      }
    }
  },
  computed: {
    ...mapGetters({
      headerUserRest: 'prvateConsultation/headerUserRest',
      orderId: 'prvateConsultation/orderId'
    })
  },
  watch: {
    orderId: {
      handler () {
        this.orderId && this.adminOnlineCaseItem()
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
.illness-history-wrap {
  /* width: 685px; */
  height: 100%;
  overflow-y: scroll;
  box-sizing: border-box;
}
.illness-history-content {
  width: 678px;
  display: inline-block;
  padding: 13px 0 50px 12px;
  box-sizing: border-box;
}
#input-text,
#select-style {
  width: 510px;
}
#select-text .ivu-form-item-label,
#input-text .ivu-form-item-label,
#input-textarea .ivu-form-item-label,
#select-style .ivu-form-item-label {
  font-size: 9px;
}
#select-style .ivu-select-selection {
  border: 1px solid rgba(181, 181, 181, 1);
}
#select-style .ivu-select-placeholder {
  height: 20px;
  line-height: 20px;
  font-size: 9px;
}
#select-style .ivu-select-dropdown-list > li,
#select-style .ivu-select-selected-value {
  font-size: 9px;
  color: #000;
}
#input-text .ivu-input,
#input-textarea .ivu-input {
  padding: 1px 8px;
  border: 1px solid rgba(181, 181, 181, 1);
  font-size: 9px;
  font-weight: 400;
  color: #000;
}
#select-text .ivu-select {
  width: 450px;
}
#select-text .ivu-select-selection {
  width: 450px;
  height: 20px;
  padding: 1px 4px;
  border: 1px solid rgba(181, 181, 181, 1);
  font-size: 9px;
  font-weight: 400;
  color: #000;
}
#select-text .ivu-select-input {
  width: 450px;
  height: 20px;
  padding: 1px 4px;
  font-size: 9px;
  font-weight: 400;
  color: #000;
  line-height: 20px;
}
#select-text .ivu-select-dropdown {
  width: 450px;
  padding: 1px 4px;
  font-size: 9px;
  font-weight: 400;
  color: #000;
  line-height: 20px;
}
#select-text .ivu-select-selection-focused,
#input-text .ivu-input:focus,
#input-textarea .ivu-input:focus {
  outline: none;
  border-color: rgba(114, 190, 255, 1);
  box-shadow: 0 0 2px rgba(114, 190, 255, 1);
}
// #input-text .ivu-form-item-error-tip {
//   padding-top: 0;
//   font-size: 6px;
// }
// #input-textarea {
//   width: 550px;
//   display: inline-block;
//   margin-bottom: 0Px;
// }
// #form-input .ivu-form-item-label {
//   width: 70px;
// }
// #form-input.form-inputNo .ivu-form-item-label{
//   width: 2.1875rem;
//   padding-top: 0;
//   padding-bottom: 0;
//   line-height: 45Px;
// }
// #form-input .ivu-form-item-content {
//   margin-left: 70px;
// }
#form-input .add-icon-style {
  width: 10px;
  height: 10px;
  position: absolute;
  top: 28px;
  left: -25px;
  cursor: pointer;
}
#form-input .sub-icon-style {
  width: 10px;
  height: 10px;
  position: absolute;
  top: 12px;
  right: -20px;
  cursor: pointer;
}
#input-textarea .ivu-form-item-error-tip {
  padding-top: 5px;
  font-size: 6px;
}
.FormItem {
  // margin-bottom: 0px !important;
  // label{
  //   height: 45Px;
  //   line-height: 45Px;
  // }
  textarea,
  .content-wp {
    border: none !important;
    background: url('~@/assets/images/line_bg.png');
    line-height: 45px;
    outline: none !important;
    resize: none;
    &:focus {
      box-shadow: none !important;
      background: url('~@/assets/images/line_bg2.png');
    }
  }
  .Select {
    * {
      font-size: 9px !important;
    }
    .ivu-select-selection {
      border: none !important;
      background: url('~@/assets/images/line_bg.png');
      background-size: contain;
    }
    &.ivu-select-visible {
      .ivu-select-selection {
        background: url('~@/assets/images/line_bg2.png');
        background-size: contain;
        box-shadow: none;
      }
    }
  }
}
.illness-submit {
  height: 20px;
  display: flex;
  justify-content: flex-end;
}
.illness-submit > div {
  width: 60px;
  height: 20px;
  background: rgba(114, 190, 255, 1);
  border-radius: 2px;
  font-size: 9px;
  line-height: 20px;
  text-align: center;
  color: #f5f9fa;
  cursor: pointer;
}
.form-span-style {
  font-size: 9px;
  color: #333;
}
.diagnosisBox {
  // margin-bottom: 0.5rem;
  position: relative;
}
.show-diagnosis-item {
  position: absolute;
  right: 0;
  top: 0;
  font-size: 0.3rem;
}
.show-diagnosis-item > span {
  display: inline-block;
  width: 49%;
}
.show-diagnosis-item-code {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/private_consultation_page/fun_right/illness_history/index.vue